import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import dayjs from 'dayjs';
import { Grid } from '@mantine/core';
import { prototypeEntryActions, projectEntryActions } from '../../store';
import { handleFetchError, isTimeEntryDateValid } from '@/helpers';
import { errorSavingEntry, errorSavingEntryHours } from '../../shared/constants/toastrErrorMsg';
import { GrsEnvironmentUrl } from '@/helpers/environmentHelpers';
import NewHourInput from '../../components/ProjectEntrySection/HoursInput/NewHourInput';
import { HeaderRow, StyledArrowIcon } from './styled';
import { ProjectEntryRow } from '../../components/ProjectEntrySection/RowContent/styled';

const PrototypeSection = ({
  prototype,
}) => {
  const dispatch = useDispatch();
  const userId = useSelector(state => state.user.activeUser?.oid);
  const selectedDays = useSelector(state => state.projectEntry.projectEntries.selectedDays);
  const NumberOfPreviousTimeEntryMonthsAllowed = useSelector(state => state.config.configuration.NumberOfPreviousTimeEntryMonthsAllowed);

  const [isOpen, setIsOpen] = useState(true);

  const getItem = (part, process, date) => {
    const entry = process.timeEntries.find(entry => dayjs(entry.timeEntry.entryDate).format('MM/DD/YYYY 00:00:00') === dayjs(date).format('MM/DD/YYYY 00:00:00'))
    return {
      timeEntry: {
        ...entry?.timeEntry,
        hours: entry ? entry.timeEntry.hours : 0,
        categoryId: part.partId,
        subCategoryId: process.processId,
        systemId: process.systemId,
      },      
    };  
  }

  const getErrMsg = (e) => {
    // If error has a Message property (from ValidationErrorResponse), use it directly
    if (e && e.Message) {
      return { title: 'Error: Project Entries', message: e.Message };
    }
    if (e.Message === errorSavingEntryHours.message) {
      return errorSavingEntryHours;
    }
    return errorSavingEntry;
  }

  const handleInputChange = async (change, finishedLoading, resetValueCallback) => {
    if (change.previousValue == change.entry.hours) {
      finishedLoading();
      return;
    }

    const dateOnly = dayjs(change.date).format('YYYY-MM-DD');

    try{
      await dispatch(prototypeEntryActions.upsertPrototypeTimeEntry(
        userId,
        dateOnly,
        change.entry.hours,
        prototype.projectNumber,
        change.entry.categoryId,
        change.entry.subCategoryId,
        prototype.requestId,
        prototype.requestNumber
      ));

      var updateCompletedMonth = dayjs(dateOnly).month() === dayjs(selectedDays[0]).month();
      await dispatch(
        projectEntryActions.updateCompletedWeeks(change.newValue - change.previousValue, updateCompletedMonth)
      );
    }
    catch (e) {
      handleFetchError(e, getErrMsg(e));
      resetValueCallback();
    }
    finally {
      finishedLoading();
    }
  }


  const url = prototype?.requestId ? `${GrsEnvironmentUrl()}/requests/prototyperequest/${prototype.requestId}`: null

  const headerTitle = `GPRS-${prototype.requestNumber}`;

  return (    
    <>
      <HeaderRow onClick={() => setIsOpen(!isOpen)}>
        <StyledArrowIcon icon="angle-right" isOpen={isOpen} />
        <span>{headerTitle}</span>
      </HeaderRow>

      {
        prototype.parts.map((part, partIndex) => {
          return part.processes.map((process, processIndex) => {
            return (
              <ProjectEntryRow key={partIndex} align='center' active={isOpen} style={{marginRight: '3px'}}>
                <Grid.Col lg={8} md={7} xs={12}>
                  <Grid>
                    <Grid.Col span={5}>
                      <p data-test={`cid-${partIndex}-part-${processIndex}`}>
                        <a href={url} target="_blank" rel="noreferrer">{(part.partDescription ?? 'no part description - link to GPRS request') + (part.isDeleted ? ' (deleted)' : '')}</a>
                      </p>
                    </Grid.Col>
                    <Grid.Col span={5}>
                      <p data-test={`cid-${partIndex}-process`}>
                        {process.processName}
                      </p>
                    </Grid.Col>
                    <Grid.Col span={2}>
                      <img
                        src={`/api/image/${part.partId}`}
                        alt="tools"
                        width="70"
                        height="40"
                        data-test={`cid-${partIndex}-img`}
                      />
                    </Grid.Col>
                  </Grid>
                </Grid.Col>
                <Grid.Col lg={4} md={5} sm={8} xs={12}>
                  <Grid sm={{ justify: 'space-around'}}>
                    {selectedDays.map((date) => {
                      const item = getItem(part, process, date)
                      return <NewHourInput id={date} key={`part-${partIndex}-process-${processIndex}-key-${date}`} entry={item.timeEntry} editable={isTimeEntryDateValid(date, NumberOfPreviousTimeEntryMonthsAllowed)} date={dayjs(date).format('MM/DD/YYYY 00:00:00')} handleInputChange={handleInputChange} />
                    })}
                  </Grid>
                </Grid.Col>
              </ProjectEntryRow> 
            )
          })
        })
      }    
    </>
  )
}

PrototypeSection.propTypes = {
  prototype: PropTypes.object
}

export default PrototypeSection;